import {
	IonPage,
	IonContent,
	IonList,
	IonItem,
	IonButton,
	IonLabel,
	IonInput,
	IonTextarea,
	IonRow,
	IonIcon,
	IonToggle,
	IonCol,
	useIonAlert,
	IonText,
	IonModal,
	IonCard
} from "@ionic/react";
import { person, location, star, diamond, storefrontSharp, checkmarkCircleOutline, starHalf, arrowForwardCircle, barbell } from 'ionicons/icons';
import CommonHeader from "../components/CommonHeader";
import SportsDropdown from "../components/SportsDropdown";
import { useContext, useEffect, useState } from "react";
import GenderRadio from "../components/GenderRadio";
import useUser from "../hooks/useUser";
import ProfileImage from "../components/ProfileImage";
import { Users } from "../services/api";
import useAuth from "../hooks/useAuth";
import { convertGenderStringToGenderObject, validateAnyZip, validateEmail } from "../services/util";
import useDynamicInputs from "../hooks/useDynamicInputs";
import AddressDropdown from "../components/AddressDropdown";
import NewAddressInputs from "../components/NewAddressInputs";
import useToast from "../hooks/useToast";
import useDarkTheme from "../hooks/useDarkTheme";
import { moon, sunny } from "ionicons/icons";
import { RouteComponentProps,useHistory } from "react-router-dom";
import { AuthenticationService } from "services/auth";
import { UserContext } from "State/UserContext";
import styled from "styled-components";

import { useParams } from "react-router";
import useAsyncEffect from "use-async-effect";

import AbsoluteSpinner from 'components/AbsoluteSpinner';
import WaveHeader from '../components/WaveHeader';
import PageTitle from '../components/PageTitle';
import VariableText from 'components/VariableText';
import SportsAddPage from './SportsAddPage';
import StarRatingComponent from 'react-star-rating-component';
import WelcomeCard from 'components/WelcomeCard';
import Card from '../components/Card';
import ChallengeForm from '../components/ChallengeForm';

import Stats from "components/Stats";


const FriendProfileEditPage: React.FC<RouteComponentProps> = (props) => {
	let { id } = useParams<Params>();
  //console.log("Profile ID value", id);
	const { token, userID } = useAuth();
	//console.log("Login id", userID);
	const { genders, sports } = useDynamicInputs();
	const { userRefresh } = useUser();

	//const { state: { user, userLoading } } = useContext(UserContext);
	//const [user, setUserList] = useState<any>([]);

	const [firstName, setFirstName] = useState<string>("");
	const [lastName, setLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [age, setAge] = useState<number | null>(18);
	const [gender, setGender] = useState<string>("");
	const [bio, setBio] = useState<string>("");
	const [selectedSports, setSelectedSports] = useState<string[]>([]);
	const [primaryAddress, setPrimaryAddress] = useState<any>();
	const [lineOne, setLineOne] = useState<string>("");
	const [lineTwo, setLineTwo] = useState<string>("");
	const [city, setCity] = useState<string>("");
	const [state, setState] = useState<string>("");
	const [zipCode, setZipCode] = useState<string>("");
	const [toast] = useToast("Hello");
	const { prefersDark } = useDarkTheme();
	const [present] = useIonAlert();

    const dev = false;
    const { user, userLoading } = useUser(id);
	const [showPill, setShowPill] = useState<boolean>(false);
    const detailsSize = "12px";
	const [showProfileImage, setShowProfileImage] = useState<boolean>(false);
    const history = useHistory();
	const [modalOpen, setModalOpen] = useState(false);
	const [sportData, setSportData] = useState<any>([]);
	const [showMainContent, setShowMainContent] = useState<boolean>(false);
	const [sportRank, setSportRank] = useState<any>("");

	//console.log("User data fetch", user);

	const isUserProfile = () => {
		if (userID === null) return false;
		return (id === undefined || id == userID);
	}

		const getSportsDetails = async () => {
			try {
				let response = await Users.getAllUserSportList(token ?? "");
				let sports = response.payload;
				setSportData(sports);
				return sports;
	
			} catch (error) {
				return [];
			}
		}


			async function sportActiveDeactive(id: any, check: any) {
		
				try {
					let post = { sport_id: id, active: check, user_id: user?.id };
					let response = await Users.updateSportsActiveDeactive(token ?? "", post);
					if (response) {
						toast({ message: response.message });
						getSportsDetails();
					}
				}
				catch {
					toast({ message: "Something went wrong" }, true);
				}
			}



	const deleteAccount = async () => {
		if (userID) {
			const response = await Users.delete(token ?? "", userID);
			if (response) {
				AuthenticationService.logout();
			}
			console.log("DELETE USER RESPONSE", response);
		}
	}


		const getSportRankvalue = async (useridVal: any) => {
				let sportname = localStorage.getItem('sportsintiallySel');
				console.log("Sport name", sportname);  
				let userID = useridVal;
				//console.log("User ID clicked", userID);
				var response = await Users.getUserSportRank(token ?? "",sportname,userID);
				console.log("Sport Rank", response);
				//console.log(response.payload[0].rank);
				let getrankval = response.payload[0]?.rank;
				//console.log("Show rank value", getrankval);
				setSportRank(getrankval);
			
		}

  
	
//   useAsyncEffect(async () => {
//     if (id){
// 		  const userlist = await Users.getUser(token ?? "", id);
//       if (userlist.success){
//         console.log('Friend view response', userlist.payload);
//         // const { message, start_date, end_date, location, event_name, slots, open_invite,venue,openSlots } = result.payload;
//         // setTitle(event_name);
//         setUserList(userlist.payload);
        
//       }
//     }
//   }, [token])




	// useEffect(() => {
	// 	setFirstName((user) ? user.first_name : "");
	// 	setLastName((user) ? user.last_name : "");
	// 	setEmail((user) ? user.email : "");
	// 	setAge((user && user.preference && user.preference.age) ? user.preference?.age : null);
	// 	setGender((user && user.preference && user.preference.gender) ? user?.preference?.gender?.name : "");
	// 	setBio((user && user.preference && user.preference.bio) ? user.preference?.bio : "");
		
	// 	var addr = user?.preference?.primary_address?.address_line_1;
	// 	var city = user?.preference?.primary_address?.city;
	// 	var state = user?.preference?.primary_address?.state;
	// 	var fullAddress = addr + ' ' + city + ' ' + state;

	// 	setPrimaryAddress((user) ? fullAddress:null);

	// }, [user])



       useEffect(() => {
			setShowPill(false);
			setShowProfileImage(false);
			setShowMainContent(false);
			setTimeout(() => {
				let shouldShowPill = !!(
					(user && user.preference && (user.preference.age_range || user.preference.gender)) ||
					(user && user.preference && user.preference.location) ||
					(user && user.preference && user.preference.verified_email)
				);
				setShowPill(shouldShowPill);
				setShowProfileImage(true);
				setShowMainContent(true);
			}, 200);
			// userRefresh();
			getSportsDetails();
			//teamList();
		}, [user, id]);

      
		// useEffect(() => {
		// 	getSportRankvalue(id)
		//   }, [token,id]);


	return (
		<IonPage>
			<IonContent fullscreen>
				{(userLoading) ? <AbsoluteSpinner /> : null}

				{/*
					WAVE HEADER
				*/}
				<WaveHeader color="accent-two" gradient={true} loading={userLoading}>
					<IonRow>
						<ProfileDetails>
							<PageTitle color="main">
								<VariableText text={(user && user.full_name) ? user.full_name : ""} />
							</PageTitle>

							<DetailsPill show={showPill && !userLoading} style={{paddingTop: "14px",paddingBottom: "14px", paddingLeft: "11px", paddingRight: "11px"}}>

								{/* Only show this row if age or gender has been set*/}
								{(user && user.preference && (user.preference.age_range || user.preference.gender)) ? (
									<IonRow style={{ fontSize: detailsSize }} className="ion-align-items-center horizontal-gutter">
										<IonIcon style={{ marginRight: "5px" }} color="main" icon={person} />
										<IonText color="main" style={{fontWeight:600}}>
											{(user && user.preference && user.preference.age_range) ? user.preference.age_range : null}
											{
												(
													(user && user.preference && user.preference.age_range) &&
													(user && user.preference && user.preference.gender)
												) ? ', ' : null
											}
											{(user && user.preference && user.preference.gender) ? user.preference.gender.name : null}
										</IonText>
									</IonRow>
								) : null}

								{/* Only show this row if the location is set */}
								{(user && user.preference && user.preference.location) ?
									(
										<IonRow style={{ fontSize: detailsSize }} className="ion-align-items-center horizontal-gutter">
											<IonIcon style={{ marginRight: "5px" }} color="main" icon={location} />
											<IonText color="main" style={{fontWeight:600}}>{user && user.preference?.location}</IonText>
										</IonRow>
									) : null}

								{/* Only show this row if the users email is verified */}
								{(user && user.preference && user.preference.verified_email) ?
									(
										<IonRow style={{ fontSize: detailsSize }} className="ion-align-items-center horizontal-gutter">
											<IonIcon style={{ marginRight: "5px" }} color="main" icon={checkmarkCircleOutline} />
											<IonText color="main" style={{fontWeight:600}}>Verified Email</IonText>
										</IonRow>
									) : null}

							</DetailsPill>

						</ProfileDetails>
						<ProfileContainer show={(showProfileImage || showPill) && !userLoading}>
							{
								(user) ? (
									<ProfileImage
										icon_color="accent-two"
										icon_type={(isUserProfile()) ? "edit" : "none"}
										filename={user?.preference?.image}
										size="47%"
										minSize="50px"
										maxSize="175px"
										icon_offset="-7px"
									/>) : null
							}
						</ProfileContainer>
					</IonRow>
				</WaveHeader>

				{/*CHALLENGE BUTTON*/}
							{
				           <IonButton
								expand="block"
								//routerLink="/challengelist/"{$id}
								onClick={() => {
									history.push(`/challengelist/${id}`);
									}}
								style={{ margin: 24 }}
							>
								Challenge
							</IonButton>
                            }
													{/*
									USER RATING AND CREDITS
								*/}
									<IonRow style={{ fontSize: "15px" }} className="ion-align-items-center ion-justify-content-between">
										{(isUserProfile())
											?
											<IonButton
												expand="block"
												onClick={() => setModalOpen(!modalOpen)}
												style={{ margin: 14 }}
											>
												Add Sports
											</IonButton>
											: []
										}

										<IonModal isOpen={modalOpen}>
											<SportsAddPage
												usertoken={token}
												getSportsDetails={getSportsDetails}
												onCloseClick={() => setModalOpen(false)}
											/>
										</IonModal>
                                        
										{/* <div style={{marginRight:"1000px"}}>
											<IonText style={{ fontSize: "15px",marginLeft: "23px" }}>Rating</IonText>
											<StarRatingComponent
												name="user-rating"
												value={(user && user.rating) ?? 0}
												editing={false}
												starColor={"var(--ion-color-text)"}
												emptyStarColor="#777"
												renderStarIcon={() => <IonIcon icon={star} />}
												renderStarIconHalf={() => <IonIcon icon={starHalf} />}
											/>
										</div> */}

										<IonRow style={{width:"100%"}}>
											   <IonText style={{ fontSize: "15px",marginLeft: "23px" }}>Rating</IonText>
										</IonRow>

										<IonRow style={{paddingLeft:"22px", marginTop:"5px"}}>
											   {/* <StarRatingComponent
												name="user-rating"
												value={(user && user.rating) ?? 0}
												editing={false}
												starColor={"var(--ion-color-text)"}
												emptyStarColor="#777"
												renderStarIcon={() => <IonIcon icon={star} />}
												renderStarIconHalf={() => <IonIcon icon={starHalf} />}
											/> */}

											 <IonText style={{background:"transparent", color:"#000", padding:"4px 0px", borderRadius:"5px"}}>
                                               {Number(user?.rating ?? 0).toFixed(1)} <IonIcon icon={star} style={{color:"#000", marginLeft: "5px", width: "15px"}} />
                                             </IonText>
										</IonRow>


										{
											(isUserProfile() && user && user.preference) ? (
												<IonRow className="ion-align-items-center" style={{ fontSize: "20px" }}>
													<IonButton
														shape="round"
														color="main"
														style={{ fontSize: "12px" }}
														routerLink="/store"
													>
														<IonIcon style={{ marginRight: "15px", fontSize: "16px" }} color="constant-light" icon={diamond} />
														<IonText style={{ fontSize: "11px" }}>Buy Credits</IonText>
													</IonButton>
													<IonIcon style={{ margin: "0 5px 0 10px", fontSize: "16px" }} color="main-text" icon={diamond} />
													<IonText style={{ fontSize: "15px" }}>{user?.credits}</IonText>
												</IonRow>
											) : null
										}
									</IonRow>
									{/* <IonLabel >{teamData?.lenght}</IonLabel> */}
									
				{/*
					MAIN PROFILE BODY
				*/}
				<MainContent show={showMainContent && !userLoading}>
					<div className="horizontal-gutter" style={{ marginTop: '25px' }}>
						<IonCol className="ion-justify-content-between">
							<div>
								
								<div className="horizontal-gutter">
                                  <Stats />
								</div>

								{/*
								WELCOME CARD
							*/}
								{(
									isUserProfile() && (
										((user && user.preference) && !user.preference.verified_email)) ||
									(user && user.preference && user.preference.addresses && user.preference.addresses.length <= 0)
								) ?
									(
										<WelcomeCard user={user} />
									) : null}

								{/*
								BIO
							*/}
								{(!isUserProfile()) ?
									(
										<div style={{marginInline:"8px"}}><Card title={`Bio`}>
											<IonRow style={{ fontSize: "15px", paddingTop: '10px' }} className="ion-align-items-center">
												{user && user.preference.bio}
											</IonRow>
										</Card></div>
									) : null}
							</div>

							{
								(isUserProfile()) ?
								<IonCard>
								<IonItem>
									<IonLabel><b>Sports</b></IonLabel>
									<IonLabel style={{ textAlign: 'right' }}><b>Active</b></IonLabel>
								</IonItem>
								{
									(sportData && sportData) ?
										(
											sportData.map((sport_obj: any) => (
												<IonItem>
													<IonLabel>{sport_obj.sport.name}</IonLabel>
													<RankName>{sport_obj.rank}</RankName>
													<IonToggle checked={sport_obj.active} onIonChange={e => sportActiveDeactive(sport_obj.sport_id, e.detail.checked)} />
												</IonItem>
											))
										) : [null]
								}
							</IonCard>
								: null
							}
							


							{/* <IonItem>
						
              <IonLabel>Open Invite</IonLabel> 
              {<IonToggle checked={open_invite} onIonChange={e => setOpenInvite(e.detail.checked)} />
            </IonItem> */}


							{/*
							PAST CHALLENGES
						*/}
             <br/>
						<IonLabel style={{marginLeft:"20px"}}>Past Matches (Coming soon)</IonLabel>

							{/* {(!isUserProfile()) ? (
						<ChallengesListOnlyCard
							title="Past Challenges"
							challenges={past}
							contextual_user_id={id}
							searchPrompt={isUserProfile()}
							hideTitleOnNoResults={!isUserProfile()}
							actions={[]}
							allowViewChallenge={isUserProfile()}
							showActions={isUserProfile()}
							{...props}
						/>
						):null} */}

							{/*
							CHALLENGE BUTTON
						*/}
							{
								(isUserProfile() || user?.sports[0]?.name === undefined) ? null : (
									<div>

										<IonModal isOpen={modalOpen}>
											<ChallengeForm onCloseClick={() => setModalOpen(false)} user={user} />
										</IonModal>
									</div>
								)
							}

							{/*
							ACCOUNT SETTINGS BUTTON
						*/}
							{
								isUserProfile() && (
									<IonButton
										expand="block"
										routerLink="/account-settings"
										style={{ margin: 14 }}
									>
										Account Settings
									</IonButton>
								)
							}

						</IonCol>
					</div>
				</MainContent>
				{(dev) ? (<div style={{ padding: "var(--horizontal-gutter)", height: "400px" }}>
					<IonRow><IonText>Primary Address</IonText></IonRow>
					<IonRow><IonText>{user?.preference?.primary_address?.address_line_1}</IonText></IonRow>
					<IonRow><IonText>{user?.preference?.primary_address?.address_line_2}</IonText></IonRow>
					<IonRow><IonText>{user?.preference?.primary_address?.city}, {user?.preference?.primary_address?.state} {user?.preference?.primary_address?.postal_code}</IonText></IonRow>
					<IonRow><IonText>{user?.preference?.primary_address?.lat}, {user?.preference?.primary_address?.lon}</IonText></IonRow>
				</div>) : null}
			</IonContent>
		</IonPage>
	);
};

export default FriendProfileEditPage
const DangerZone = styled.div`
	margin-top: 50px;
	padding: 20px;
	border-radius: 15px;
	border: 5px solid var(--ion-color-danger);
`;

const DangerZoneHeader = styled.div`
	padding-bottom: 50px;
`;

const DangerZoneTitle = styled.h1`
	font-family: var(--heading-font);
`;

const DangerZoneMessage = styled.div`
	font-size: 13px;
`;

const DangerZoneContent = styled.div`
`;


const RankName = styled.div`
	width:53%;
`;
const ProfileDetails = styled(IonCol)`
	flex: 2;
`;

const DetailsPill = styled.div<{ show: boolean }>`
	background: var(--ion-color-accent-one);
	letter-spacing: 0.4px;
	padding: 10px;
	padding-left: 0;
	width: max-content;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 50px;
	box-shadow: 0 0 4px rgba(13,13,13,0.3);
	transition: margin-left 0.3s;
	margin-left: ${props => `${(props.show) ? "0" : "-100%"}`};
	font-family: var(--heading-font);
	& * {
		font-size: 12px;
	}
`;

const ProfileContainer = styled.div<{ show: boolean }>`
	flex: 1;
	padding-right: 3%;
	transition: margin-right 0.3s;
	margin-right: ${props => `${(props.show) ? "0" : "-100%"}`};
`;

const MainContent = styled.div<{ show: boolean }>`
	transition: margin-top 0.3s;
	margin-top: ${props => `${(props.show) ? "0" : "150%"}`}
`;